import script from "./Conference.vue?vue&type=script&setup=true&lang=js"
export * from "./Conference.vue?vue&type=script&setup=true&lang=js"

import "./Conference.vue?vue&type=style&index=0&id=6027c261&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6027c261"]])

export default __exports__